/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Layout Helpers
   ========================================================================== */
.content-l {
  position: relative;
}
@media only all and (min-width: 37.5625em) {
  .content-l {
    display: block;
    position: relative;
    margin-left: -15px;
    margin-right: -15px;
  }
}

@media only all and (max-width: 37.5em) {
  .content-l__col + .content-l__col {
    margin-top: 1.875em;
  }
}

@media only all and (min-width: 37.5625em) {
  .content-l__col-1 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-1-2 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 50%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-1-3 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 33.3333333333%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-2-3 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 66.6666666667%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-3-8 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 37.5%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-5-8 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 62.5%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-1-4 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 25%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content-l__col-3-4 {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 75%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
}
.content__line {
  height: 1px;
  background: var(--gray-40);
}

.content__main dd,
.content__main dt,
.content__main h3,
.content__main h4,
.content__main h5,
.content__main h6,
.content__main li,
.content__main p,
.content__main label,
.content__intro dd,
.content__intro dt,
.content__intro h3,
.content__intro h4,
.content__intro h5,
.content__intro h6,
.content__intro li,
.content__intro p,
.content__intro label {
  max-width: 41.875rem;
}

.content__intro,
.content__main,
.content__sidebar {
  padding: 1.875em 0.9375em;
}
@media only all and (min-width: 37.5625em) {
  .content__intro,
  .content__main,
  .content__sidebar {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
    padding: 2.8125em 0.9375em;
  }
}
@media only all and (min-width: 56.3125em) {
  .content__intro,
  .content__main,
  .content__sidebar {
    padding: 2.8125em 0;
  }
}

@media only all and (min-width: 56.3125em) {
  .content__intro {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
}
@media only all and (min-width: 56.3125em) {
  .content--1-3 .content__sidebar {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 25%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
    padding-right: 1.875em;
  }
  .content--1-3 .content__main {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 75%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
    position: relative;
  }
  .content--1-3 .content__main::after {
    content: "";
    border-left: 1px solid var(--gray-40);
    position: absolute;
    top: 2.8125em;
    bottom: 0;
    left: -1.875em;
  }
  .content--2-1 .content__main {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 66.6666666667%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
  }
  .content--2-1 .content__main::after {
    right: -1.875em;
  }
  .content--2-1 .content__sidebar {
    /* stylelint-enable */
    display: inline-block;
    box-sizing: border-box;
    width: 33.3333333333%;
    border: solid transparent;
    border-width: 0 15px;
    margin-right: -0.25em;
    vertical-align: top;
    padding-left: 1.875em;
  }
}
.content--flush-bottom {
  padding-bottom: 0;
}

@media only all and (max-width: 56.25em) {
  .content--flush-top-on-small {
    padding-top: 0;
  }
}

@media only all and (max-width: 56.25em) {
  .content--flush-all-on-small {
    padding: 0;
    border: none;
  }
}

.block {
  margin-top: 3.75em;
  margin-bottom: 3.75em;
}
.block--border-top {
  border-top: 1px solid var(--gray-40);
}
.block--border-right {
  border-right: 1px solid var(--gray-40);
}
.block--border-bottom {
  border-bottom: 1px solid var(--gray-40);
}
.block--border-left {
  border-left: 1px solid var(--gray-40);
}
.block--border {
  border: 1px solid var(--gray-40);
}
.block--flush-top {
  margin-top: 0 !important;
}
.block--flush-top.block--border, .block--flush-top.block--border-top {
  border-top: none;
}
.block--flush-bottom {
  margin-bottom: 0 !important;
}
.block--flush-bottom.block--border, .block--flush-bottom.block--border-bottom {
  border-bottom: none;
}
.block--flush-sides {
  margin-right: -15px;
  margin-left: -15px;
}
@media only all and (max-width: 37.5em) {
  .block--flush-sides.block--border, .block--flush-sides.block--border-right, .block--flush-sides.block--border-left {
    border-right: none;
    border-left: none;
  }
}
@media only all and (min-width: 37.5625em) {
  .block--flush-sides {
    margin-right: -30px;
    margin-left: -30px;
  }
}
.block--flush {
  margin-top: 0 !important;
  margin-right: -15px;
  margin-bottom: 0 !important;
  margin-left: -15px;
}
.block--flush.block--border, .block--flush.block--border-top, .block--flush.block--border-bottom {
  border-top: none;
  border-bottom: none;
}
@media only all and (max-width: 37.5em) {
  .block--flush.block--border, .block--flush.block--border-right, .block--flush.block--border-left {
    border-right: none;
    border-left: none;
  }
}
@media only all and (min-width: 37.5625em) {
  .block--flush {
    margin-right: -30px;
    margin-left: -30px;
  }
}
.block--bg {
  padding: 1.875em 0.9375em;
  padding-bottom: 3.75em;
  background: var(--gray-5);
}
@media only all and (min-width: 37.5625em) {
  .block--bg {
    padding: 2.8125em 1.875em;
  }
}
.block--padded-top {
  padding-top: 1.875em;
  margin-top: 1.875em;
}
.block--padded-bottom {
  padding-bottom: 1.875em;
  margin-bottom: 1.875em;
}
.block--sub {
  margin-top: 1.875em;
  margin-bottom: 1.875em;
}

@media only all and (min-width: 56.3125em) {
  .wrapper {
    /* stylelint-enable */
    max-width: 1200px;
    padding-right: 15px;
    padding-left: 15px;
    margin: 0 auto;
    clear: both;
  }
}
.wrapper--match-content {
  padding-left: 15px;
  padding-right: 15px;
}
@media only all and (min-width: 37.5625em) {
  .wrapper--match-content {
    padding-left: 30px;
    padding-right: 30px;
    max-width: 1200px;
  }
}